// UI Translations for all supported languages
// Order based on Hiroshima visitor statistics

const translations = {
  // English (default)
  en: {
    // Language selector
    languageLabel: 'Language',

    // Name input
    enterName: 'What\'s your name?',
    namePlaceholder: 'e.g., John Smith (first name only is also OK)',
    start: 'Start',
    next: 'Next',
    back: 'Back',

    // Result page
    yourKanjiName: 'Your Kanji Name',
    matchingScore: 'Matching Score',
    total: 'Total',
    gender: 'Gender',
    motivation: 'Motivation',

    // Calligrapher section
    calligrapherTitle: 'A Calligrapher Will Write Your Name with a Brush',
    calligrapherDesc: 'A professional calligrapher will write your kanji name in beautiful brush calligraphy and send it to you via email.',
    calligrapherDescPaid: 'Enter your email address to receive your handwritten calligraphy artwork.',
    emailWarning: '※If the email address is incorrect, we will not be able to deliver your artwork. Please enter it carefully.',
    emailPlaceholder: 'Email address',
    request: 'Request',
    sendCalligraphy: 'Apply',
    sending: 'Sending...',
    thankYou: 'Thank you! Your calligraphy will be delivered to your email within one week.',
    requestError: 'Failed to send request. Please try again.',

    // Share section
    shareTitle: 'Share your kanji name',
    copyTag: 'Copy',
    copyText: 'Copy',

    // Landing page
    landingTitle: 'Get Your Unique Kanji Name',
    landingDesc: 'Discover your personalized Japanese kanji name, handwritten by a professional calligrapher and delivered to your email.',
    feature1: 'Answer questions that explore your inner self',
    feature2: 'Your unique kanji name is generated',
    feature3: 'Professional calligraphy delivered by email',
    priceLabel: 'Service Fee',
    termsLink: 'Terms of Service',
    startFree: 'Start Free',

    // New landing page
    lpHeroTitle: "What's Your Japanese Name?",
    lpHeroSub: 'Personality quiz + Kanji name + Calligraphy + Your personal story',
    lpHeroCta: 'Get Started',
    lpHeroLang: 'Available in 11 languages',
    lpGalleryTitle: 'Every name tells a story',
    lpGalleryMeaning1: "A quiet perfectionist with a creator's fire inside",
    lpGalleryMeaning2: 'Sees truth clearly, leads without hesitation',
    lpGalleryMeaning3: 'Fiercely independent, yet warmest among those she loves',
    lpGalleryMeaning4: 'Intellect like polished jade, peace like a still lake',
    lpHowTitle: 'How It Works',
    lpStep1: 'Take a 2-min personality quiz',
    lpStep2: 'Enter your email address',
    lpStep3: 'We\'ll send your perfect kanji name & its meaning',
    lpStep3Detail: 'Delivered to your email within 10 minutes',
    lpStep3Detail2: 'Handwritten calligraphy within 3 business days',
    lpProofText: 'Loved by 5,000+ travelers',
    lpCtaTagline: 'Your trip. Your name. Your story.',

    // Loading messages
    scrollHintCalligraphy: 'Enter your email to receive a calligraphy artwork',

    // Email prompt (before generation)
    emailPromptMessage: 'Your name is about to be generated. If you\'d like to receive the results and calligraphy image by email, please enter your email address. Leave blank if not needed.',
    emailPromptSkip: 'Skip',
    emailPromptSubmit: 'Submit',

    loading1: 'Analyzing your personality...',
    loading2: 'Selecting the perfect kanji...',
    loading3: 'Creating your story...',
    loading4: 'Enter your email on the next page to receive your calligraphy',

    // Email input screen (after quiz)
    emailInputTitle: 'Please enter your email address',
    emailInputDesc: "We'll send your perfect kanji name and its story within 10 minutes",
    emailInputCalligraphy: 'Calligraphy by our calligrapher: delivered within 3 business days (excl. weekends/holidays)',
    emailSubmittedThankYou: "Thank you! We'll send your kanji name and its meaning to your email within 10 minutes.",
    emailSubmittedCalligraphy: 'Your handwritten calligraphy will be delivered within 3 business days (excl. weekends/holidays).',

    // Error handling
    sessionError: 'Failed to prepare your session. Please try again.',
    generationError: 'Failed to generate your result. Please try again.',
    paymentRequiredError: "We couldn't confirm your payment. Please try again.",
    retry: 'Retry',

    // Start new diagnosis
    startNew: 'Start New Quiz',

    // Payment modal
    paymentNotCompleted: 'Payment was not completed. Please try again.',
    cancel: 'Cancel',
    processing: 'Processing...',
    payAndStart: 'Pay {{amount}} & Start',
    demoCodeRequired: 'Please enter a code.',
    demoCodeInvalid: 'Invalid code.',
    demoCodeError: 'An error occurred while verifying the code.',
    demoValidating: 'Checking...',
    demoApply: 'Apply',
    paymentInitFailed: 'Failed to initialize payment',
    demoApplied: 'Demo code applied!',
    preparingPayment: 'Preparing payment...',
    close: 'Close',
    promoCodeToggle: 'Have a promo code?',
    completePurchase: 'Complete Your Purchase',
    loadingRestore: 'Checking your previous result...'
  },

  // French
  fr: {
    languageLabel: 'Langue',
    enterName: 'Comment vous appelez-vous ?',
    namePlaceholder: 'ex. : Jean Dupont (prénom seul aussi OK)',
    start: 'Commencer',
    next: 'Suivant',
    back: 'Retour',

    yourKanjiName: 'Votre nom en kanji',
    matchingScore: 'Score de correspondance',
    total: 'Total',
    gender: 'Genre',
    motivation: 'Motivation',

    calligrapherTitle: 'Un calligraphe \u00e9crira votre nom au pinceau',
    calligrapherDesc: 'Un calligraphe professionnel \u00e9crira votre nom en kanji dans une belle calligraphie au pinceau et vous l\'enverra par e-mail.',
    calligrapherDescPaid: 'Entrez votre adresse e-mail pour recevoir votre calligraphie manuscrite.',
    emailWarning: '※Si l\'adresse e-mail est incorrecte, nous ne pourrons pas vous livrer votre œuvre. Veuillez la saisir avec soin.',
    emailPlaceholder: 'Adresse e-mail',
    request: 'Demander',
    sendCalligraphy: 'S\'inscrire',
    sending: 'Envoi en cours...',
    thankYou: 'Merci ! Votre calligraphie vous sera envoy\u00e9e par e-mail sous une semaine.',
    requestError: 'Échec de l\'envoi. Veuillez réessayer.',
    shareTitle: 'Partagez votre nom en kanji',
    copyTag: 'Copier',
    copyText: 'Copier',

    landingTitle: 'Obtenez votre nom Kanji unique',
    landingDesc: 'Découvrez votre nom japonais personnalisé en kanji, écrit à la main par un calligraphe professionnel.',
    feature1: 'Répondez à des questions qui explorent votre personnalité profonde',
    feature2: 'Votre nom kanji unique est généré',
    feature3: 'Calligraphie professionnelle envoyée par e-mail',
    priceLabel: 'Frais de service',
    termsLink: 'Conditions d\'utilisation',
    startFree: 'Commencer gratuitement',

    lpHeroTitle: 'Quel est votre nom japonais ?',
    lpHeroSub: 'Quiz de personnalité + Nom en kanji + Calligraphie + Votre histoire personnelle',
    lpHeroCta: 'Commencer',
    lpHeroLang: 'Disponible en 11 langues',
    lpGalleryTitle: 'Chaque nom raconte une histoire',
    lpGalleryMeaning1: 'Un perfectionniste discret, habité par le feu d\'un créateur',
    lpGalleryMeaning2: 'Voit la vérité clairement, dirige sans hésitation',
    lpGalleryMeaning3: 'Farouchement indépendante, mais la plus chaleureuse parmi ceux qu\'elle aime',
    lpGalleryMeaning4: 'Un intellect de jade poli, une paix de lac immobile',
    lpHowTitle: 'Comment ça marche',
    lpStep1: 'Répondez à un quiz de personnalité de 2 min',
    lpStep2: 'Entrez votre adresse e-mail',
    lpStep3: 'Nous vous envoyons votre nom kanji parfait et sa signification',
    lpStep3Detail: 'Livré par e-mail sous 10 minutes',
    lpStep3Detail2: 'Calligraphie manuscrite sous 3 jours ouvrés',
    lpProofText: 'Adoré par plus de 5 000 voyageurs',
    lpCtaTagline: 'Votre voyage. Votre nom. Votre histoire.',

    scrollHintCalligraphy: 'Entrez votre e-mail pour recevoir une calligraphie',

    emailPromptMessage: 'Votre nom va être généré. Si vous souhaitez recevoir les résultats et l\'image de calligraphie par e-mail, veuillez entrer votre adresse e-mail. Laissez vide si ce n\'est pas nécessaire.',
    emailPromptSkip: 'Passer',
    emailPromptSubmit: 'Envoyer',

    loading1: 'Analyse de votre personnalit\u00e9...',
    loading2: 'S\u00e9lection des kanji parfaits...',
    loading3: 'Cr\u00e9ation de votre histoire...',
    loading4: 'Entrez votre e-mail sur la page suivante pour recevoir votre calligraphie',

    emailInputTitle: 'Veuillez entrer votre adresse e-mail',
    emailInputDesc: 'Nous vous enverrons votre nom kanji parfait et son histoire sous 10 minutes',
    emailInputCalligraphy: 'Calligraphie par notre calligraphe : livrée sous 3 jours ouvrés (hors week-ends/jours fériés)',
    emailSubmittedThankYou: 'Merci ! Nous vous enverrons votre nom kanji et sa signification par e-mail sous 10 minutes.',
    emailSubmittedCalligraphy: 'Votre calligraphie manuscrite sera livrée sous 3 jours ouvrés (hors week-ends/jours fériés).',

    // Error handling
    sessionError: 'Échec de la préparation de votre session. Veuillez réessayer.',
    generationError: 'Échec de la génération de votre résultat. Veuillez réessayer.',
    paymentRequiredError: 'Échec de la confirmation de votre paiement. Veuillez réessayer.',
    retry: 'Réessayer',

    // Start new diagnosis
    startNew: 'Commencer un nouveau quiz',

    // Payment modal
    paymentNotCompleted: 'Le paiement n\'a pas été finalisé. Veuillez réessayer.',
    cancel: 'Annuler',
    processing: 'Traitement en cours...',
    payAndStart: 'Payer {{amount}} et commencer',
    demoCodeRequired: 'Veuillez saisir un code.',
    demoCodeInvalid: 'Code invalide.',
    demoCodeError: 'Une erreur est survenue lors de la vérification du code.',
    demoValidating: 'Vérification...',
    demoApply: 'Appliquer',
    paymentInitFailed: 'Échec de l\'initialisation du paiement.',
    demoApplied: 'Code de démonstration appliqué !',
    preparingPayment: 'Préparation du paiement...',
    close: 'Fermer',
    promoCodeToggle: 'Vous avez un code promo ?',
    completePurchase: 'Finalisez votre achat',
    loadingRestore: 'Vérification de votre résultat précédent...'
  },

  // German
  de: {
    languageLabel: 'Sprache',
    enterName: 'Wie heißen Sie?',
    namePlaceholder: 'z.B. Max Müller (nur Vorname auch OK)',
    start: 'Starten',
    next: 'Weiter',
    back: 'Zurück',

    yourKanjiName: 'Ihr Kanji-Name',
    matchingScore: '\u00dcbereinstimmungswert',
    total: 'Gesamt',
    gender: 'Geschlecht',
    motivation: 'Motivation',

    calligrapherTitle: 'Ein Kalligraph schreibt Ihren Namen mit dem Pinsel',
    calligrapherDesc: 'Ein professioneller Kalligraph wird Ihren Kanji-Namen in sch\u00f6ner Pinselkalligraphie schreiben und Ihnen per E-Mail zusenden.',
    calligrapherDescPaid: 'Geben Sie Ihre E-Mail-Adresse ein, um Ihr handgeschriebenes Kalligraphie-Kunstwerk zu erhalten.',
    emailWarning: '※Wenn die E-Mail-Adresse falsch ist, können wir Ihr Kunstwerk nicht liefern. Bitte geben Sie sie sorgfältig ein.',
    emailPlaceholder: 'E-Mail-Adresse',
    request: 'Anfordern',
    sendCalligraphy: 'Anmelden',
    sending: 'Wird gesendet...',
    thankYou: 'Vielen Dank! Ihre Kalligraphie wird Ihnen innerhalb einer Woche per E-Mail zugesandt.',
    requestError: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
    shareTitle: 'Teilen Sie Ihren Kanji-Namen',
    copyTag: 'Kopieren',
    copyText: 'Kopieren',

    landingTitle: 'Erhalten Sie Ihren einzigartigen Kanji-Namen',
    landingDesc: 'Entdecken Sie Ihren personalisierten japanischen Kanji-Namen, handgeschrieben von einem professionellen Kalligraphen.',
    feature1: 'Beantworten Sie Fragen, die Ihr inneres Selbst erkunden',
    feature2: 'Ihr einzigartiger Kanji-Name wird generiert',
    feature3: 'Professionelle Kalligraphie per E-Mail geliefert',
    priceLabel: 'Servicegebühr',
    termsLink: 'Nutzungsbedingungen',
    startFree: 'Kostenlos starten',

    lpHeroTitle: 'Wie lautet Ihr japanischer Name?',
    lpHeroSub: 'Persönlichkeitsquiz + Kanji-Name + Kalligraphie + Ihre persönliche Geschichte',
    lpHeroCta: 'Jetzt starten',
    lpHeroLang: 'In 11 Sprachen verfügbar',
    lpGalleryTitle: 'Jeder Name erzählt eine Geschichte',
    lpGalleryMeaning1: 'Ein stiller Perfektionist mit dem Feuer eines Schöpfers im Inneren',
    lpGalleryMeaning2: 'Erkennt die Wahrheit klar, führt ohne Zögern',
    lpGalleryMeaning3: 'Wild unabhängig, aber die Wärmste unter denen, die sie liebt',
    lpGalleryMeaning4: 'Intellekt wie geschliffene Jade, Frieden wie ein stiller See',
    lpHowTitle: 'So funktioniert es',
    lpStep1: 'Machen Sie ein 2-minütiges Persönlichkeitsquiz',
    lpStep2: 'Geben Sie Ihre E-Mail-Adresse ein',
    lpStep3: 'Wir senden Ihnen Ihren perfekten Kanji-Namen und seine Bedeutung',
    lpStep3Detail: 'Zustellung per E-Mail innerhalb von 10 Minuten',
    lpStep3Detail2: 'Handgeschriebene Kalligraphie innerhalb von 3 Werktagen',
    lpProofText: 'Beliebt bei über 5.000 Reisenden',
    lpCtaTagline: 'Ihre Reise. Ihr Name. Ihre Geschichte.',

    scrollHintCalligraphy: 'E-Mail eingeben, um ein Kalligraphie-Kunstwerk zu erhalten',

    emailPromptMessage: 'Ihr Name wird gleich generiert. Wenn Sie die Ergebnisse und das Kalligraphie-Bild per E-Mail erhalten möchten, geben Sie bitte Ihre E-Mail-Adresse ein. Leer lassen, wenn nicht benötigt.',
    emailPromptSkip: 'Überspringen',
    emailPromptSubmit: 'Absenden',

    loading1: 'Analyse Ihrer Pers\u00f6nlichkeit...',
    loading2: 'Auswahl der perfekten Kanji...',
    loading3: 'Erstellung Ihrer Geschichte...',
    loading4: 'Geben Sie auf der nächsten Seite Ihre E-Mail ein, um Ihre Kalligraphie zu erhalten',

    emailInputTitle: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    emailInputDesc: 'Wir senden Ihnen Ihren perfekten Kanji-Namen und seine Geschichte innerhalb von 10 Minuten',
    emailInputCalligraphy: 'Kalligraphie von unserem Kalligraphen: Zustellung innerhalb von 3 Werktagen (ohne Wochenenden/Feiertage)',
    emailSubmittedThankYou: 'Vielen Dank! Wir senden Ihren Kanji-Namen und seine Bedeutung innerhalb von 10 Minuten an Ihre E-Mail.',
    emailSubmittedCalligraphy: 'Ihre handgeschriebene Kalligraphie wird innerhalb von 3 Werktagen (ohne Wochenenden/Feiertage) zugestellt.',

    // Error handling
    sessionError: 'Vorbereitung Ihrer Sitzung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    generationError: 'Generierung Ihres Ergebnisses fehlgeschlagen. Bitte versuchen Sie es erneut.',
    paymentRequiredError: 'Zahlungsbestätigung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    retry: 'Erneut versuchen',

    // Start new diagnosis
    startNew: 'Neues Quiz starten',

    // Payment modal
    paymentNotCompleted: 'Die Zahlung wurde nicht abgeschlossen. Bitte versuchen Sie es erneut.',
    cancel: 'Abbrechen',
    processing: 'Wird verarbeitet...',
    payAndStart: '{{amount}} zahlen & starten',
    demoCodeRequired: 'Bitte geben Sie einen Code ein.',
    demoCodeInvalid: 'Ungültiger Code.',
    demoCodeError: 'Bei der Überprüfung des Codes ist ein Fehler aufgetreten.',
    demoValidating: 'Wird überprüft...',
    demoApply: 'Anwenden',
    paymentInitFailed: 'Initialisierung der Zahlung fehlgeschlagen.',
    demoApplied: 'Demo-Code angewendet!',
    preparingPayment: 'Zahlung wird vorbereitet...',
    close: 'Schließen',
    promoCodeToggle: 'Sie haben einen Promo-Code?',
    completePurchase: 'Schließen Sie Ihren Kauf ab',
    loadingRestore: 'Ihr vorheriges Ergebnis wird überprüft...'
  },

  // Spanish
  es: {
    languageLabel: 'Idioma',
    enterName: '¿Cómo te llamas?',
    namePlaceholder: 'ej. Juan García (solo nombre también OK)',
    start: 'Comenzar',
    next: 'Siguiente',
    back: 'Atrás',

    yourKanjiName: 'Tu nombre en kanji',
    matchingScore: 'Puntuaci\u00f3n de coincidencia',
    total: 'Total',
    gender: 'G\u00e9nero',
    motivation: 'Motivaci\u00f3n',

    calligrapherTitle: 'Un cal\u00edgrafo escribir\u00e1 tu nombre con pincel',
    calligrapherDesc: 'Un cal\u00edgrafo profesional escribir\u00e1 tu nombre en kanji con hermosa caligraf\u00eda de pincel y te lo enviar\u00e1 por correo electr\u00f3nico.',
    calligrapherDescPaid: 'Ingresa tu correo electrónico para recibir tu caligrafía manuscrita.',
    emailWarning: '※Si el correo electrónico es incorrecto, no podremos entregar tu obra. Por favor, ingrésalo con cuidado.',
    emailPlaceholder: 'Correo electr\u00f3nico',
    request: 'Solicitar',
    sendCalligraphy: 'Solicitar',
    sending: 'Enviando...',
    thankYou: '\u00a1Gracias! Su caligraf\u00eda ser\u00e1 enviada a su correo electr\u00f3nico en un plazo de una semana.',
    requestError: 'Error al enviar. Por favor, int\u00e9ntalo de nuevo.',
    shareTitle: 'Comparta su nombre en kanji',
    copyTag: 'Copiar',
    copyText: 'Copiar',

    landingTitle: 'Obtén tu nombre Kanji único',
    landingDesc: 'Descubre tu nombre japonés personalizado en kanji, escrito a mano por un calígrafo profesional.',
    feature1: 'Responde preguntas que exploran tu ser interior',
    feature2: 'Se genera tu nombre kanji único',
    feature3: 'Caligrafía profesional enviada por correo',
    priceLabel: 'Tarifa del servicio',
    termsLink: 'Términos de servicio',
    startFree: 'Comenzar gratis',

    lpHeroTitle: '¿Cuál es tu nombre japonés?',
    lpHeroSub: 'Quiz de personalidad + Nombre en kanji + Caligrafía + Tu historia personal',
    lpHeroCta: 'Comenzar',
    lpHeroLang: 'Disponible en 11 idiomas',
    lpGalleryTitle: 'Cada nombre cuenta una historia',
    lpGalleryMeaning1: 'Un perfeccionista silencioso con el fuego de un creador por dentro',
    lpGalleryMeaning2: 'Ve la verdad con claridad, lidera sin vacilación',
    lpGalleryMeaning3: 'Ferozmente independiente, pero la más cálida entre quienes ama',
    lpGalleryMeaning4: 'Intelecto como jade pulido, paz como un lago en calma',
    lpHowTitle: 'Cómo funciona',
    lpStep1: 'Realiza un quiz de personalidad de 2 minutos',
    lpStep2: 'Ingresa tu correo electrónico',
    lpStep3: 'Te enviamos tu nombre kanji perfecto y su significado',
    lpStep3Detail: 'Entregado a tu correo en 10 minutos',
    lpStep3Detail2: 'Caligrafía manuscrita en 3 días hábiles',
    lpProofText: 'Amado por más de 5.000 viajeros',
    lpCtaTagline: 'Tu viaje. Tu nombre. Tu historia.',

    scrollHintCalligraphy: 'Ingresa tu correo para recibir una caligrafía',

    emailPromptMessage: 'Tu nombre está a punto de ser generado. Si deseas recibir los resultados y la imagen de caligrafía por correo electrónico, ingresa tu dirección de correo. Déjalo en blanco si no es necesario.',
    emailPromptSkip: 'Omitir',
    emailPromptSubmit: 'Enviar',

    loading1: 'Analizando tu personalidad...',
    loading2: 'Seleccionando los kanji perfectos...',
    loading3: 'Creando tu historia...',
    loading4: 'Ingresa tu correo en la siguiente página para recibir tu caligrafía',

    emailInputTitle: 'Por favor, ingresa tu correo electrónico',
    emailInputDesc: 'Te enviaremos tu nombre kanji perfecto y su historia en 10 minutos',
    emailInputCalligraphy: 'Caligrafía de nuestro calígrafo: entregada en 3 días hábiles (excl. fines de semana/festivos)',
    emailSubmittedThankYou: '¡Gracias! Te enviaremos tu nombre kanji y su significado a tu correo en 10 minutos.',
    emailSubmittedCalligraphy: 'Tu caligrafía manuscrita será entregada en 3 días hábiles (excl. fines de semana/festivos).',

    // Error handling
    sessionError: 'Error al preparar tu sesión. Por favor, inténtalo de nuevo.',
    generationError: 'Error al generar tu resultado. Por favor, inténtalo de nuevo.',
    paymentRequiredError: 'Error al confirmar tu pago. Por favor, inténtalo de nuevo.',
    retry: 'Reintentar',

    // Start new diagnosis
    startNew: 'Comenzar un nuevo quiz',

    // Payment modal
    paymentNotCompleted: 'El pago no se completó. Por favor, inténtalo de nuevo.',
    cancel: 'Cancelar',
    processing: 'Procesando...',
    payAndStart: 'Pagar {{amount}} y comenzar',
    demoCodeRequired: 'Por favor, ingresa un código.',
    demoCodeInvalid: 'Código no válido.',
    demoCodeError: 'Error al verificar el código.',
    demoValidating: 'Comprobando...',
    demoApply: 'Aplicar',
    paymentInitFailed: 'Error al inicializar el pago.',
    demoApplied: '¡Código de demostración aplicado!',
    preparingPayment: 'Preparando el pago...',
    close: 'Cerrar',
    promoCodeToggle: '¿Tienes un código promocional?',
    completePurchase: 'Completa tu compra',
    loadingRestore: 'Comprobando tu resultado anterior...'
  },

  // Portuguese
  pt: {
    languageLabel: 'Idioma',
    enterName: 'Qual é o seu nome?',
    namePlaceholder: 'ex. João Silva (só primeiro nome também OK)',
    start: 'Começar',
    next: 'Próximo',
    back: 'Voltar',

    yourKanjiName: 'Seu nome em kanji',
    matchingScore: 'Pontuação de correspondência',
    total: 'Total',
    gender: 'Gênero',
    motivation: 'Motivação',

    calligrapherTitle: 'Um calígrafo escreverá seu nome com pincel',
    calligrapherDesc: 'Um calígrafo profissional escreverá seu nome em kanji com bela caligrafia a pincel e enviará para você por e-mail.',
    calligrapherDescPaid: 'Insira seu endereço de e-mail para receber sua obra de caligrafia manuscrita.',
    emailWarning: '※Se o endereço de e-mail estiver incorreto, não poderemos entregar sua obra. Por favor, insira com cuidado.',
    emailPlaceholder: 'Endereço de e-mail',
    request: 'Solicitar',
    sendCalligraphy: 'Solicitar',
    sending: 'Enviando...',
    thankYou: 'Obrigado! Sua caligrafia ser\u00e1 enviada para o seu e-mail dentro de uma semana.',
    requestError: 'Falha ao enviar. Por favor, tente novamente.',
    shareTitle: 'Compartilhe seu nome em kanji',
    copyTag: 'Copiar',
    copyText: 'Copiar',

    landingTitle: 'Obtenha seu nome Kanji único',
    landingDesc: 'Descubra seu nome japonês personalizado em kanji, escrito à mão por um calígrafo profissional.',
    feature1: 'Responda perguntas que exploram seu eu interior',
    feature2: 'Seu nome kanji único é gerado',
    feature3: 'Caligrafia profissional entregue por e-mail',
    priceLabel: 'Taxa de serviço',
    termsLink: 'Termos de serviço',
    startFree: 'Começar grátis',

    lpHeroTitle: 'Qual é o seu nome japonês?',
    lpHeroSub: 'Quiz de personalidade + Nome em kanji + Caligrafia + Sua história pessoal',
    lpHeroCta: 'Começar',
    lpHeroLang: 'Disponível em 11 idiomas',
    lpGalleryTitle: 'Cada nome conta uma história',
    lpGalleryMeaning1: 'Um perfeccionista silencioso com o fogo de um criador por dentro',
    lpGalleryMeaning2: 'Vê a verdade com clareza, lidera sem hesitação',
    lpGalleryMeaning3: 'Ferozmente independente, mas a mais calorosa entre aqueles que ama',
    lpGalleryMeaning4: 'Intelecto como jade polido, paz como um lago sereno',
    lpHowTitle: 'Como funciona',
    lpStep1: 'Faça um quiz de personalidade de 2 minutos',
    lpStep2: 'Insira seu endereço de e-mail',
    lpStep3: 'Enviaremos seu nome kanji perfeito e seu significado',
    lpStep3Detail: 'Entregue por e-mail em 10 minutos',
    lpStep3Detail2: 'Caligrafia manuscrita em 3 dias úteis',
    lpProofText: 'Amado por mais de 5.000 viajantes',
    lpCtaTagline: 'Sua viagem. Seu nome. Sua história.',

    scrollHintCalligraphy: 'Insira seu e-mail para receber uma obra de caligrafia',

    emailPromptMessage: 'Seu nome está prestes a ser gerado. Se deseja receber os resultados e a imagem de caligrafia por e-mail, insira seu endereço de e-mail. Deixe em branco se não for necessário.',
    emailPromptSkip: 'Pular',
    emailPromptSubmit: 'Enviar',

    loading1: 'Analisando sua personalidade...',
    loading2: 'Selecionando os kanji perfeitos...',
    loading3: 'Criando sua história...',
    loading4: 'Insira seu e-mail na próxima página para receber sua caligrafia',

    emailInputTitle: 'Por favor, insira seu endereço de e-mail',
    emailInputDesc: 'Enviaremos seu nome kanji perfeito e sua história em 10 minutos',
    emailInputCalligraphy: 'Caligrafia pelo nosso calígrafo: entregue em 3 dias úteis (excl. fins de semana/feriados)',
    emailSubmittedThankYou: 'Obrigado! Enviaremos seu nome kanji e seu significado para seu e-mail em 10 minutos.',
    emailSubmittedCalligraphy: 'Sua caligrafia manuscrita será entregue em 3 dias úteis (excl. fins de semana/feriados).',

    // Error handling
    sessionError: 'Falha ao preparar sua sessão. Por favor, tente novamente.',
    generationError: 'Falha ao gerar seu resultado. Por favor, tente novamente.',
    paymentRequiredError: 'Falha ao confirmar seu pagamento. Por favor, tente novamente.',
    retry: 'Tentar novamente',

    // Start new diagnosis
    startNew: 'Começar um novo quiz',

    // Payment modal
    paymentNotCompleted: 'O pagamento não foi concluído. Por favor, tente novamente.',
    cancel: 'Cancelar',
    processing: 'Processando...',
    payAndStart: 'Pagar {{amount}} e começar',
    demoCodeRequired: 'Por favor, insira um código.',
    demoCodeInvalid: 'Código inválido.',
    demoCodeError: 'Falha ao verificar o código.',
    demoValidating: 'Verificando...',
    demoApply: 'Aplicar',
    paymentInitFailed: 'Falha ao inicializar o pagamento.',
    demoApplied: 'Código de demonstração aplicado!',
    preparingPayment: 'Preparando o pagamento...',
    close: 'Fechar',
    promoCodeToggle: 'Tem um código promocional?',
    completePurchase: 'Conclua sua compra',
    loadingRestore: 'Verificando seu resultado anterior...'
  },

  // Italian
  it: {
    languageLabel: 'Lingua',
    enterName: 'Come ti chiami?',
    namePlaceholder: 'es. Mario Rossi (solo nome anche OK)',
    start: 'Inizia',
    next: 'Avanti',
    back: 'Indietro',

    yourKanjiName: 'Il tuo nome in kanji',
    matchingScore: 'Punteggio di corrispondenza',
    total: 'Totale',
    gender: 'Genere',
    motivation: 'Motivazione',

    calligrapherTitle: 'Un calligrafo scriver\u00e0 il tuo nome con il pennello',
    calligrapherDesc: 'Un calligrafo professionista scriver\u00e0 il tuo nome in kanji con bella calligrafia a pennello e te lo invier\u00e0 via e-mail.',
    calligrapherDescPaid: 'Inserisci il tuo indirizzo e-mail per ricevere la tua calligrafia scritta a mano.',
    emailWarning: '※Se l\'indirizzo e-mail è errato, non saremo in grado di consegnare la tua opera. Per favore, inseriscilo con attenzione.',
    emailPlaceholder: 'Indirizzo e-mail',
    request: 'Richiedi',
    sendCalligraphy: 'Richiedi',
    sending: 'Invio in corso...',
    thankYou: 'Grazie! La tua calligrafia ti sar\u00e0 inviata via e-mail entro una settimana.',
    requestError: 'Invio non riuscito. Riprova.',
    shareTitle: 'Condividi il tuo nome in kanji',
    copyTag: 'Copia',
    copyText: 'Copia',

    landingTitle: 'Ottieni il tuo nome Kanji unico',
    landingDesc: 'Scopri il tuo nome giapponese personalizzato in kanji, scritto a mano da un calligrafo professionista.',
    feature1: 'Rispondi a domande che esplorano il tuo io interiore',
    feature2: 'Il tuo nome kanji unico viene generato',
    feature3: 'Calligrafia professionale consegnata via e-mail',
    priceLabel: 'Tariffa del servizio',
    termsLink: 'Termini di servizio',
    startFree: 'Inizia gratis',

    lpHeroTitle: 'Qual è il tuo nome giapponese?',
    lpHeroSub: 'Quiz di personalità + Nome in kanji + Calligrafia + La tua storia personale',
    lpHeroCta: 'Inizia ora',
    lpHeroLang: 'Disponibile in 11 lingue',
    lpGalleryTitle: 'Ogni nome racconta una storia',
    lpGalleryMeaning1: 'Un perfezionista silenzioso con il fuoco di un creatore dentro',
    lpGalleryMeaning2: 'Vede la verità con chiarezza, guida senza esitazione',
    lpGalleryMeaning3: 'Ferocemente indipendente, eppure la più calorosa tra chi ama',
    lpGalleryMeaning4: 'Intelletto come giada levigata, pace come un lago immobile',
    lpHowTitle: 'Come funziona',
    lpStep1: 'Fai un quiz di personalità di 2 minuti',
    lpStep2: 'Inserisci il tuo indirizzo e-mail',
    lpStep3: 'Ti invieremo il tuo nome kanji perfetto e il suo significato',
    lpStep3Detail: 'Consegnato alla tua e-mail entro 10 minuti',
    lpStep3Detail2: 'Calligrafia manuscritta entro 3 giorni lavorativi',
    lpProofText: 'Amato da oltre 5.000 viaggiatori',
    lpCtaTagline: 'Il tuo viaggio. Il tuo nome. La tua storia.',

    scrollHintCalligraphy: 'Inserisci la tua e-mail per ricevere un\'opera di calligrafia',

    emailPromptMessage: 'Il tuo nome sta per essere generato. Se desideri ricevere i risultati e l\'immagine della calligrafia via e-mail, inserisci il tuo indirizzo e-mail. Lascia vuoto se non necessario.',
    emailPromptSkip: 'Salta',
    emailPromptSubmit: 'Invia',

    loading1: 'Analisi della tua personalit\u00e0...',
    loading2: 'Selezione dei kanji perfetti...',
    loading3: 'Creazione della tua storia...',
    loading4: 'Inserisci la tua e-mail nella prossima pagina per ricevere la tua calligrafia',

    emailInputTitle: 'Inserisci il tuo indirizzo e-mail',
    emailInputDesc: 'Ti invieremo il tuo nome kanji perfetto e la sua storia entro 10 minuti',
    emailInputCalligraphy: 'Calligrafia dal nostro calligrafo: consegnata entro 3 giorni lavorativi (esclusi weekend/festivi)',
    emailSubmittedThankYou: 'Grazie! Ti invieremo il tuo nome kanji e il suo significato via e-mail entro 10 minuti.',
    emailSubmittedCalligraphy: 'La tua calligrafia scritta a mano sarà consegnata entro 3 giorni lavorativi (esclusi weekend/festivi).',

    // Error handling
    sessionError: 'Preparazione della sessione non riuscita. Riprova.',
    generationError: 'Generazione del risultato non riuscita. Riprova.',
    paymentRequiredError: 'Conferma del pagamento non riuscita. Riprova.',
    retry: 'Riprova',

    // Start new diagnosis
    startNew: 'Inizia un nuovo quiz',

    // Payment modal
    paymentNotCompleted: 'Il pagamento non è stato completato. Riprova.',
    cancel: 'Annulla',
    processing: 'Elaborazione in corso...',
    payAndStart: 'Paga {{amount}} e inizia',
    demoCodeRequired: 'Inserisci un codice.',
    demoCodeInvalid: 'Codice non valido.',
    demoCodeError: 'Errore durante la verifica del codice.',
    demoValidating: 'Verifica in corso...',
    demoApply: 'Applica',
    paymentInitFailed: 'Inizializzazione del pagamento non riuscita.',
    demoApplied: 'Codice demo applicato!',
    preparingPayment: 'Preparazione del pagamento...',
    close: 'Chiudi',
    promoCodeToggle: 'Hai un codice promozionale?',
    completePurchase: 'Completa il tuo acquisto',
    loadingRestore: 'Verifica del tuo risultato precedente...'
  },

  // Thai
  th: {
    languageLabel: '\u0E20\u0E32\u0E29\u0E32',
    enterName: 'คุณชื่ออะไร?',
    namePlaceholder: 'เช่น สมชาย ใจดี (ชื่อเดียวก็ OK)',
    start: '\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19',
    next: '\u0E16\u0E31\u0E14\u0E44\u0E1B',
    back: 'ย้อนกลับ',

    yourKanjiName: '\u0E0A\u0E37\u0E48\u0E2D\u0E04\u0E31\u0E19\u0E08\u0E34\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13',
    matchingScore: '\u0E04\u0E30\u0E41\u0E19\u0E19\u0E04\u0E27\u0E32\u0E21\u0E40\u0E02\u0E49\u0E32\u0E01\u0E31\u0E19',
    total: '\u0E23\u0E27\u0E21',
    gender: '\u0E40\u0E1E\u0E28',
    motivation: '\u0E41\u0E23\u0E07\u0E08\u0E39\u0E07\u0E43\u0E08',

    calligrapherTitle: '\u0E19\u0E31\u0E01\u0E40\u0E02\u0E35\u0E22\u0E19\u0E1E\u0E39\u0E48\u0E01\u0E31\u0E19\u0E08\u0E30\u0E40\u0E02\u0E35\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22\u0E1E\u0E39\u0E48\u0E01\u0E31\u0E19',
    calligrapherDesc: '\u0E19\u0E31\u0E01\u0E40\u0E02\u0E35\u0E22\u0E19\u0E1E\u0E39\u0E48\u0E01\u0E31\u0E19\u0E21\u0E37\u0E2D\u0E2D\u0E32\u0E0A\u0E35\u0E1E\u0E08\u0E30\u0E40\u0E02\u0E35\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E04\u0E31\u0E19\u0E08\u0E34\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22\u0E1E\u0E39\u0E48\u0E01\u0E31\u0E19\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E27\u0E34\u0E08\u0E34\u0E15\u0E23\u0E2D\u0E31\u0E19\u0E2A\u0E27\u0E22\u0E07\u0E32\u0E21 \u0E41\u0E25\u0E30\u0E2A\u0E48\u0E07\u0E16\u0E36\u0E07\u0E04\u0E38\u0E13\u0E17\u0E32\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25',
    calligrapherDescPaid: 'กรอกอีเมลของคุณเพื่อรับงานเขียนพู่กันที่เขียนด้วยมือ',
    emailWarning: '※หากอีเมลไม่ถูกต้อง เราจะไม่สามารถส่งผลงานให้คุณได้ กรุณากรอกอย่างระมัดระวัง',
    emailPlaceholder: '\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25',
    request: '\u0E02\u0E2D\u0E23\u0E31\u0E1A',
    sendCalligraphy: 'สมัคร',
    sending: '\u0E01\u0E33\u0E25\u0E31\u0E07\u0E2A\u0E48\u0E07...',
    thankYou: '\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13! \u0E07\u0E32\u0E19\u0E40\u0E02\u0E35\u0E22\u0E19\u0E1E\u0E39\u0E48\u0E01\u0E31\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E17\u0E32\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E20\u0E32\u0E22\u0E43\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C',
    requestError: '\u0E2A\u0E48\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07',
    shareTitle: '\u0E41\u0E0A\u0E23\u0E4C\u0E0A\u0E37\u0E48\u0E2D\u0E04\u0E31\u0E19\u0E08\u0E34\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13',
    copyTag: '\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01',
    copyText: '\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01',

    landingTitle: 'รับชื่อคันจิที่ไม่ซ้ำใครของคุณ',
    landingDesc: 'ค้นพบชื่อญี่ปุ่นเฉพาะตัวในรูปแบบคันจิ เขียนด้วยมือโดยนักเขียนพู่กันมืออาชีพ',
    feature1: 'ตอบคำถามที่สำรวจตัวตนภายในของคุณ',
    feature2: 'ชื่อคันจิที่เป็นเอกลักษณ์ของคุณถูกสร้างขึ้น',
    feature3: 'งานเขียนพู่กันมืออาชีพส่งทางอีเมล',
    priceLabel: 'ค่าบริการ',
    termsLink: 'ข้อกำหนดการใช้บริการ',
    startFree: 'เริ่มต้นฟรี',

    lpHeroTitle: 'ชื่อญี่ปุ่นของคุณคืออะไร?',
    lpHeroSub: 'แบบทดสอบบุคลิกภาพ + ชื่อคันจิ + ลายมือพู่กัน + เรื่องราวของคุณ',
    lpHeroCta: 'เริ่มเลย',
    lpHeroLang: 'รองรับ 11 ภาษา',
    lpGalleryTitle: 'ทุกชื่อมีเรื่องราว',
    lpGalleryMeaning1: 'นักสมบูรณ์แบบผู้เงียบสงบ มีไฟของนักสร้างสรรค์อยู่ภายใน',
    lpGalleryMeaning2: 'มองเห็นความจริงอย่างแจ่มชัด นำทางโดยไม่ลังเล',
    lpGalleryMeaning3: 'เป็นอิสระอย่างแรงกล้า แต่อบอุ่นที่สุดในหมู่คนที่เธอรัก',
    lpGalleryMeaning4: 'สติปัญญาดุจหยกขัดเงา สงบดุจทะเลสาบนิ่ง',
    lpHowTitle: 'ขั้นตอนการใช้งาน',
    lpStep1: 'ทำแบบทดสอบบุคลิกภาพ 2 นาที',
    lpStep2: 'กรอกอีเมลของคุณ',
    lpStep3: 'เราจะส่งชื่อคันจิที่เหมาะกับคุณและความหมาย',
    lpStep3Detail: 'ส่งถึงอีเมลของคุณภายใน 10 นาที',
    lpStep3Detail2: 'งานเขียนพู่กันภายใน 3 วันทำการ',
    lpProofText: 'เป็นที่รักของนักเดินทางกว่า 5,000 คน',
    lpCtaTagline: 'การเดินทางของคุณ ชื่อของคุณ เรื่องราวของคุณ',

    scrollHintCalligraphy: 'กรอกอีเมลเพื่อรับผลงานเขียนพู่กัน',

    emailPromptMessage: 'ชื่อของคุณกำลังจะถูกสร้างขึ้น หากคุณต้องการรับผลลัพธ์และภาพเขียนพู่กันทางอีเมล กรุณากรอกอีเมลของคุณ ไม่ต้องกรอกก็ได้หากไม่ต้องการ',
    emailPromptSkip: 'ข้าม',
    emailPromptSubmit: 'ส่ง',

    loading1: '\u0E01\u0E33\u0E25\u0E31\u0E07\u0E27\u0E34\u0E40\u0E04\u0E23\u0E32\u0E30\u0E2B\u0E4C\u0E1A\u0E38\u0E04\u0E25\u0E34\u0E01\u0E20\u0E32\u0E1E\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13...',
    loading2: '\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E31\u0E19\u0E08\u0E34\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21...',
    loading3: '\u0E01\u0E33\u0E25\u0E31\u0E07\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E23\u0E32\u0E27\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13...',
    loading4: 'กรอกอีเมลในหน้าถัดไปเพื่อรับงานเขียนพู่กันของคุณ',

    emailInputTitle: 'กรุณากรอกอีเมลของคุณ',
    emailInputDesc: 'เราจะส่งชื่อคันจิที่เหมาะกับคุณและเรื่องราวภายใน 10 นาที',
    emailInputCalligraphy: 'งานเขียนพู่กันโดยนักเขียนพู่กัน: จัดส่งภายใน 3 วันทำการ (ไม่รวมวันหยุดสุดสัปดาห์/วันหยุดนักขัตฤกษ์)',
    emailSubmittedThankYou: 'ขอบคุณ! เราจะส่งชื่อคันจิและความหมายไปยังอีเมลของคุณภายใน 10 นาที',
    emailSubmittedCalligraphy: 'งานเขียนพู่กันด้วยมือจะจัดส่งภายใน 3 วันทำการ (ไม่รวมวันหยุดสุดสัปดาห์/วันหยุดนักขัตฤกษ์)',

    // Error handling
    sessionError: 'เตรียมเซสชันไม่สำเร็จ กรุณาลองอีกครั้ง',
    generationError: 'สร้างผลลัพธ์ไม่สำเร็จ กรุณาลองอีกครั้ง',
    paymentRequiredError: 'ยืนยันการชำระเงินไม่สำเร็จ กรุณาลองอีกครั้ง',
    retry: 'ลองอีกครั้ง',

    // Start new diagnosis
    startNew: 'เริ่มแบบทดสอบใหม่',

    // Payment modal
    paymentNotCompleted: 'การชำระเงินไม่สำเร็จ กรุณาลองอีกครั้ง',
    cancel: 'ยกเลิก',
    processing: 'กำลังดำเนินการ...',
    payAndStart: 'ชำระ {{amount}} และเริ่มต้น',
    demoCodeRequired: 'กรุณากรอกรหัส',
    demoCodeInvalid: 'รหัสไม่ถูกต้อง',
    demoCodeError: 'เกิดข้อผิดพลาดระหว่างการตรวจสอบรหัส',
    demoValidating: 'กำลังตรวจสอบ...',
    demoApply: 'ใช้',
    paymentInitFailed: 'ไม่สามารถเริ่มต้นการชำระเงินได้',
    demoApplied: 'ใช้รหัสเดโมเรียบร้อยแล้ว!',
    preparingPayment: 'กำลังเตรียมการชำระเงิน...',
    close: 'ปิด',
    promoCodeToggle: 'มีโค้ดโปรโมชั่น?',
    completePurchase: 'ทำการสั่งซื้อให้เสร็จสมบูรณ์',
    loadingRestore: 'กำลังตรวจสอบผลลัพธ์ก่อนหน้าของคุณ...'
  },

  // Vietnamese
  vi: {
    languageLabel: 'Ng\u00f4n ng\u1eef',
    enterName: 'Bạn tên gì?',
    namePlaceholder: 'vd: Nguyễn Văn An (chỉ tên cũng OK)',
    start: 'B\u1EAFt \u0111\u1EA7u',
    next: 'Ti\u1EBFp theo',
    back: 'Quay lại',

    yourKanjiName: 'T\u00ean Kanji c\u1EE7a b\u1EA1n',
    matchingScore: '\u0110i\u1EC3m ph\u00f9 h\u1EE3p',
    total: 'T\u1ED5ng',
    gender: 'Gi\u1EDBi t\u00ednh',
    motivation: '\u0110\u1ED9ng l\u1EF1c',

    calligrapherTitle: 'Nh\u00e0 th\u01B0 ph\u00e1p s\u1EBD vi\u1EBFt t\u00ean b\u1EA1n b\u1EB1ng b\u00fat l\u00f4ng',
    calligrapherDesc: 'Nh\u00e0 th\u01B0 ph\u00e1p chuy\u00ean nghi\u1EC7p s\u1EBD vi\u1EBFt t\u00ean kanji c\u1EE7a b\u1EA1n b\u1EB1ng th\u01B0 ph\u00e1p b\u00fat l\u00f4ng tuy\u1EC7t \u0111\u1EB9p v\u00e0 g\u1EEDi cho b\u1EA1n qua email.',
    calligrapherDescPaid: 'Nhập địa chỉ email của bạn để nhận tác phẩm thư pháp viết tay.',
    emailWarning: '※Nếu địa chỉ email không chính xác, chúng tôi sẽ không thể gửi tác phẩm cho bạn. Vui lòng nhập cẩn thận.',
    emailPlaceholder: '\u0110\u1ECBa ch\u1EC9 email',
    request: 'Y\u00eau c\u1EA7u',
    sendCalligraphy: 'Đăng ký',
    sending: '\u0110ang g\u1EEDi...',
    thankYou: 'C\u1EA3m \u01A1n b\u1EA1n! T\u00e1c ph\u1EA9m th\u01B0 ph\u00e1p s\u1EBD \u0111\u01B0\u1EE3c g\u1EEDi \u0111\u1EBFn email c\u1EE7a b\u1EA1n trong v\u00f2ng m\u1ED9t tu\u1EA7n.',
    requestError: 'G\u1EEDi kh\u00f4ng th\u00e0nh c\u00f4ng. Vui l\u00f2ng th\u1EED l\u1EA1i.',
    shareTitle: 'Chia s\u1EBB t\u00ean kanji c\u1EE7a b\u1EA1n',
    copyTag: 'Sao ch\u00e9p',
    copyText: 'Sao ch\u00e9p',

    landingTitle: 'Nhận tên Kanji độc đáo của bạn',
    landingDesc: 'Khám phá tên Nhật Bản cá nhân hóa bằng kanji, viết tay bởi nhà thư pháp chuyên nghiệp.',
    feature1: 'Trả lời câu hỏi khám phá con người bên trong bạn',
    feature2: 'Tên kanji độc đáo của bạn được tạo ra',
    feature3: 'Thư pháp chuyên nghiệp gửi qua email',
    priceLabel: 'Phí dịch vụ',
    termsLink: 'Điều khoản dịch vụ',
    startFree: 'Bắt đầu miễn phí',

    lpHeroTitle: 'Tên Nhật Bản của bạn là gì?',
    lpHeroSub: 'Trắc nghiệm tính cách + Tên kanji + Thư pháp + Câu chuyện của bạn',
    lpHeroCta: 'Bắt đầu',
    lpHeroLang: 'Hỗ trợ 11 ngôn ngữ',
    lpGalleryTitle: 'Mỗi cái tên kể một câu chuyện',
    lpGalleryMeaning1: 'Người cầu toàn thầm lặng, mang ngọn lửa sáng tạo bên trong',
    lpGalleryMeaning2: 'Nhìn thấu sự thật, dẫn dắt không do dự',
    lpGalleryMeaning3: 'Độc lập mãnh liệt, nhưng ấm áp nhất giữa những người cô yêu thương',
    lpGalleryMeaning4: 'Trí tuệ như ngọc mài sáng, bình yên như mặt hồ tĩnh lặng',
    lpHowTitle: 'Cách thức hoạt động',
    lpStep1: 'Làm bài trắc nghiệm tính cách 2 phút',
    lpStep2: 'Nhập địa chỉ email của bạn',
    lpStep3: 'Chúng tôi sẽ gửi tên kanji hoàn hảo và ý nghĩa của nó',
    lpStep3Detail: 'Gửi qua email trong vòng 10 phút',
    lpStep3Detail2: 'Thư pháp viết tay trong 3 ngày làm việc',
    lpProofText: 'Được yêu thích bởi hơn 5.000 du khách',
    lpCtaTagline: 'Chuyến đi của bạn. Tên của bạn. Câu chuyện của bạn.',

    scrollHintCalligraphy: 'Nhập email để nhận tác phẩm thư pháp',

    emailPromptMessage: 'Tên của bạn sắp được tạo. Nếu bạn muốn nhận kết quả và hình ảnh thư pháp qua email, vui lòng nhập địa chỉ email. Để trống nếu không cần.',
    emailPromptSkip: 'Bỏ qua',
    emailPromptSubmit: 'Gửi',

    loading1: '\u0110ang ph\u00e2n t\u00edch t\u00ednh c\u00e1ch c\u1EE7a b\u1EA1n...',
    loading2: '\u0110ang ch\u1ECDn kanji ho\u00e0n h\u1EA3o...',
    loading3: '\u0110ang t\u1EA1o c\u00e2u chuy\u1EC7n c\u1EE7a b\u1EA1n...',
    loading4: 'Nhập email ở trang tiếp theo để nhận tác phẩm thư pháp của bạn',

    emailInputTitle: 'Vui lòng nhập địa chỉ email của bạn',
    emailInputDesc: 'Chúng tôi sẽ gửi tên kanji hoàn hảo và câu chuyện của nó trong vòng 10 phút',
    emailInputCalligraphy: 'Thư pháp bởi nhà thư pháp: gửi trong 3 ngày làm việc (không tính cuối tuần/ngày lễ)',
    emailSubmittedThankYou: 'Cảm ơn bạn! Chúng tôi sẽ gửi tên kanji và ý nghĩa đến email của bạn trong vòng 10 phút.',
    emailSubmittedCalligraphy: 'Tác phẩm thư pháp viết tay sẽ được gửi trong vòng 3 ngày làm việc (không tính cuối tuần/ngày lễ).',

    // Error handling
    sessionError: 'Chuẩn bị phiên không thành công. Vui lòng thử lại.',
    generationError: 'Tạo kết quả không thành công. Vui lòng thử lại.',
    paymentRequiredError: 'Xác nhận thanh toán không thành công. Vui lòng thử lại.',
    retry: 'Thử lại',

    // Start new diagnosis
    startNew: 'Bắt đầu trắc nghiệm mới',

    // Payment modal
    paymentNotCompleted: 'Thanh toán chưa hoàn tất. Vui lòng thử lại.',
    cancel: 'Hủy',
    processing: 'Đang xử lý...',
    payAndStart: 'Thanh toán {{amount}} và bắt đầu',
    demoCodeRequired: 'Vui lòng nhập mã.',
    demoCodeInvalid: 'Mã không hợp lệ.',
    demoCodeError: 'Đã xảy ra lỗi trong quá trình xác minh mã.',
    demoValidating: 'Đang kiểm tra...',
    demoApply: 'Áp dụng',
    paymentInitFailed: 'Không thể khởi tạo thanh toán.',
    demoApplied: 'Đã áp dụng mã demo!',
    preparingPayment: 'Đang chuẩn bị thanh toán...',
    close: 'Đóng',
    promoCodeToggle: 'Bạn có mã khuyến mãi?',
    completePurchase: 'Hoàn tất mua hàng',
    loadingRestore: 'Đang kiểm tra kết quả trước đó của bạn...'
  },

  // Indonesian
  id: {
    languageLabel: 'Bahasa',
    enterName: 'Siapa namamu?',
    namePlaceholder: 'contoh: Budi Santoso (nama depan saja juga OK)',
    start: 'Mulai',
    next: 'Selanjutnya',
    back: 'Kembali',

    yourKanjiName: 'Nama Kanji Anda',
    matchingScore: 'Skor Kecocokan',
    total: 'Total',
    gender: 'Gender',
    motivation: 'Motivasi',

    calligrapherTitle: 'Seorang Kaligrafer Akan Menulis Nama Anda dengan Kuas',
    calligrapherDesc: 'Seorang kaligrafer profesional akan menulis nama kanji Anda dalam kaligrafi kuas yang indah dan mengirimkannya kepada Anda melalui email.',
    calligrapherDescPaid: 'Masukkan alamat email Anda untuk menerima karya kaligrafi tulisan tangan.',
    emailWarning: '※Jika alamat email salah, kami tidak dapat mengirimkan karya Anda. Harap masukkan dengan hati-hati.',
    emailPlaceholder: 'Alamat email',
    request: 'Minta',
    sendCalligraphy: 'Daftar',
    sending: 'Mengirim...',
    thankYou: 'Terima kasih! Kaligrafi Anda akan dikirim ke email Anda dalam satu minggu.',
    requestError: 'Gagal mengirim. Silakan coba lagi.',
    shareTitle: 'Bagikan nama kanji Anda',
    copyTag: 'Salin',
    copyText: 'Salin',

    landingTitle: 'Dapatkan Nama Kanji Unik Anda',
    landingDesc: 'Temukan nama Jepang pribadi Anda dalam kanji, ditulis tangan oleh kaligrafer profesional.',
    feature1: 'Jawab pertanyaan yang mengeksplorasi diri Anda yang sebenarnya',
    feature2: 'Nama kanji unik Anda dihasilkan',
    feature3: 'Kaligrafi profesional dikirim via email',
    priceLabel: 'Biaya Layanan',
    termsLink: 'Syarat Layanan',
    startFree: 'Mulai Gratis',

    lpHeroTitle: 'Siapa nama Jepang Anda?',
    lpHeroSub: 'Kuis kepribadian + Nama kanji + Kaligrafi + Kisah pribadi Anda',
    lpHeroCta: 'Mulai Sekarang',
    lpHeroLang: 'Tersedia dalam 11 bahasa',
    lpGalleryTitle: 'Setiap nama menyimpan sebuah cerita',
    lpGalleryMeaning1: 'Seorang perfeksionis yang tenang dengan api kreator di dalam dirinya',
    lpGalleryMeaning2: 'Melihat kebenaran dengan jelas, memimpin tanpa ragu',
    lpGalleryMeaning3: 'Sangat mandiri, namun paling hangat di antara orang-orang yang dicintainya',
    lpGalleryMeaning4: 'Kecerdasan bagai giok berkilau, kedamaian bagai danau yang tenang',
    lpHowTitle: 'Cara Kerjanya',
    lpStep1: 'Ikuti kuis kepribadian 2 menit',
    lpStep2: 'Masukkan alamat email Anda',
    lpStep3: 'Kami akan mengirimkan nama kanji sempurna dan maknanya',
    lpStep3Detail: 'Dikirim ke email Anda dalam 10 menit',
    lpStep3Detail2: 'Kaligrafi tulisan tangan dalam 3 hari kerja',
    lpProofText: 'Disukai oleh lebih dari 5.000 wisatawan',
    lpCtaTagline: 'Perjalanan Anda. Nama Anda. Kisah Anda.',

    scrollHintCalligraphy: 'Masukkan email untuk menerima karya kaligrafi',

    emailPromptMessage: 'Nama Anda akan segera dibuat. Jika Anda ingin menerima hasil dan gambar kaligrafi melalui email, silakan masukkan alamat email Anda. Kosongkan jika tidak diperlukan.',
    emailPromptSkip: 'Lewati',
    emailPromptSubmit: 'Kirim',

    loading1: 'Menganalisis kepribadian Anda...',
    loading2: 'Memilih kanji yang sempurna...',
    loading3: 'Membuat cerita Anda...',
    loading4: 'Masukkan email di halaman berikutnya untuk menerima kaligrafi Anda',

    emailInputTitle: 'Silakan masukkan alamat email Anda',
    emailInputDesc: 'Kami akan mengirimkan nama kanji sempurna dan ceritanya dalam 10 menit',
    emailInputCalligraphy: 'Kaligrafi oleh kaligrafer kami: dikirim dalam 3 hari kerja (tidak termasuk akhir pekan/hari libur)',
    emailSubmittedThankYou: 'Terima kasih! Kami akan mengirimkan nama kanji dan maknanya ke email Anda dalam 10 menit.',
    emailSubmittedCalligraphy: 'Karya kaligrafi tulisan tangan akan dikirim dalam 3 hari kerja (tidak termasuk akhir pekan/hari libur).',

    // Error handling
    sessionError: 'Gagal menyiapkan sesi Anda. Silakan coba lagi.',
    generationError: 'Gagal membuat hasil Anda. Silakan coba lagi.',
    paymentRequiredError: 'Gagal mengonfirmasi pembayaran Anda. Silakan coba lagi.',
    retry: 'Coba lagi',

    // Start new diagnosis
    startNew: 'Mulai Kuis Baru',

    // Payment modal
    paymentNotCompleted: 'Pembayaran tidak berhasil diselesaikan. Silakan coba lagi.',
    cancel: 'Batal',
    processing: 'Memproses...',
    payAndStart: 'Bayar {{amount}} dan Mulai',
    demoCodeRequired: 'Silakan masukkan kode.',
    demoCodeInvalid: 'Kode tidak valid.',
    demoCodeError: 'Terjadi kesalahan saat memverifikasi kode.',
    demoValidating: 'Memeriksa...',
    demoApply: 'Terapkan',
    paymentInitFailed: 'Gagal menginisialisasi pembayaran.',
    demoApplied: 'Kode demo diterapkan!',
    preparingPayment: 'Menyiapkan pembayaran...',
    close: 'Tutup',
    promoCodeToggle: 'Punya kode promo?',
    completePurchase: 'Selesaikan Pembelian Anda',
    loadingRestore: 'Memeriksa hasil sebelumnya Anda...'
  },

  // Korean
  ko: {
    languageLabel: '\uc5b8\uc5b4',
    enterName: '이름이 뭐예요?',
    namePlaceholder: '예: 홍길동 (이름만도 OK)',
    start: '\uC2DC\uC791',
    next: '\uB2E4\uC74C',
    back: '이전',

    yourKanjiName: '\uB2F9\uC2E0\uC758 \uD55C\uC790 \uC774\uB984',
    matchingScore: '\uB9E4\uCE6D \uC810\uC218',
    total: '\uC885\uD569',
    gender: '\uC131\uBCC4',
    motivation: '\uB3D9\uAE30',

    calligrapherTitle: '\uC11C\uC608\uAC00\uAC00 \uBD93\uC73C\uB85C \uB2F9\uC2E0\uC758 \uC774\uB984\uC744 \uC368\uB4DC\uB9BD\uB2C8\uB2E4',
    calligrapherDesc: '\uC804\uBB38 \uC11C\uC608\uAC00\uAC00 \uC544\uB984\uB2E4\uC6B4 \uBD93\uAE00\uC528\uB85C \uB2F9\uC2E0\uC758 \uD55C\uC790 \uC774\uB984\uC744 \uC4F0\uACE0 \uC774\uBA54\uC77C\uB85C \uBCF4\uB0B4\uB4DC\uB9BD\uB2C8\uB2E4.',
    calligrapherDescPaid: '손으로 쓴 서예 작품을 받으시려면 이메일 주소를 입력하세요.',
    emailWarning: '※이메일 주소가 잘못되면 작품을 배송할 수 없습니다. 신중하게 입력해 주세요.',
    emailPlaceholder: '\uC774\uBA54\uC77C \uC8FC\uC18C',
    request: '\uC2E0\uCCAD',
    sendCalligraphy: '신청하기',
    sending: '\uC804\uC1A1 \uC911...',
    thankYou: '\uAC10\uC0AC\uD569\uB2C8\uB2E4! \uC11C\uC608 \uC791\uD488\uC740 1\uC8FC\uC77C \uC774\uB0B4\uC5D0 \uC774\uBA54\uC77C\uB85C \uBCF4\uB0B4\uB4DC\uB9BD\uB2C8\uB2E4.',
    requestError: '\uC804\uC1A1\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.',
    shareTitle: '\uD55C\uC790 \uC774\uB984\uC744 \uACF5\uC720\uD558\uC138\uC694',
    copyTag: '\uBCF5\uC0AC',
    copyText: '\uBCF5\uC0AC',

    landingTitle: '나만의 한자 이름을 받으세요',
    landingDesc: '나만의 특별한 한자 이름을 만들고, 전문 서예가가 정성껏 손글씨로 보내드립니다.',
    feature1: '내면을 탐구하는 질문에 답하세요',
    feature2: '고유한 한자 이름이 생성됩니다',
    feature3: '전문 서예를 이메일로 배송',
    priceLabel: '서비스 요금',
    termsLink: '서비스 약관',
    startFree: '무료로 시작',

    lpHeroTitle: '당신의 일본 이름은?',
    lpHeroSub: '성격 퀴즈 + 한자 이름 + 서예 + 당신만의 이야기',
    lpHeroCta: '시작하기',
    lpHeroLang: '11개 언어 지원',
    lpGalleryTitle: '모든 이름에는 이야기가 있습니다',
    lpGalleryMeaning1: '조용한 완벽주의자, 내면에 창작자의 불꽃을 품은',
    lpGalleryMeaning2: '진실을 꿰뚫어 보며, 망설임 없이 이끄는',
    lpGalleryMeaning3: '강렬히 독립적이면서도, 사랑하는 이들 사이에서 가장 따뜻한',
    lpGalleryMeaning4: '깎아낸 옥 같은 지성, 고요한 호수 같은 평화',
    lpHowTitle: '이용 방법',
    lpStep1: '2분 성격 퀴즈에 응답하기',
    lpStep2: '이메일 주소를 입력하세요',
    lpStep3: '당신에게 딱 맞는 한자 이름과 의미를 보내드립니다',
    lpStep3Detail: '10분 이내에 이메일로 전송',
    lpStep3Detail2: '손글씨 서예는 영업일 기준 3일 이내',
    lpProofText: '5,000명 이상의 여행자가 사랑한',
    lpCtaTagline: '당신의 여행. 당신의 이름. 당신의 이야기.',

    scrollHintCalligraphy: '이메일을 입력하여 서예 작품을 받으세요',

    emailPromptMessage: '이름이 곧 생성됩니다. 결과와 서예 이미지를 이메일로 받고 싶으시면 이메일 주소를 입력해 주세요. 필요 없으시면 빈칸으로 두세요.',
    emailPromptSkip: '건너뛰기',
    emailPromptSubmit: '제출',

    loading1: '\uB2F9\uC2E0\uC758 \uC131\uACA9\uC744 \uBD84\uC11D \uC911...',
    loading2: '\uC644\uBCBD\uD55C \uD55C\uC790\uB97C \uC120\uD0DD \uC911...',
    loading3: '\uB2F9\uC2E0\uC758 \uC774\uC57C\uAE30\uB97C \uC791\uC131 \uC911...',
    loading4: '다음 페이지에서 이메일을 입력하면 서예 작품을 받을 수 있습니다',

    emailInputTitle: '이메일 주소를 입력해 주세요',
    emailInputDesc: '10분 이내에 당신에게 딱 맞는 한자 이름과 이야기를 보내드립니다',
    emailInputCalligraphy: '서예가의 서예 작품: 3영업일 이내 배송 (주말/공휴일 제외)',
    emailSubmittedThankYou: '감사합니다! 10분 이내에 한자 이름과 의미를 이메일로 보내드립니다.',
    emailSubmittedCalligraphy: '손글씨 서예 작품은 3영업일 이내(주말/공휴일 제외)에 배송됩니다.',

    // Error handling
    sessionError: '세션 준비에 실패했습니다. 다시 시도해 주세요.',
    generationError: '결과 생성에 실패했습니다. 다시 시도해 주세요.',
    paymentRequiredError: '결제 확인에 실패했습니다. 다시 시도해 주세요.',
    retry: '다시 시도',

    // Start new diagnosis
    startNew: '새 퀴즈 시작하기',

    // Payment modal
    paymentNotCompleted: '결제가 완료되지 않았습니다. 다시 시도해 주세요.',
    cancel: '취소',
    processing: '처리 중...',
    payAndStart: '{{amount}} 결제하고 시작하기',
    demoCodeRequired: '코드를 입력해 주세요.',
    demoCodeInvalid: '유효하지 않은 코드입니다.',
    demoCodeError: '코드 확인 중 오류가 발생했습니다.',
    demoValidating: '확인 중...',
    demoApply: '적용',
    paymentInitFailed: '결제 초기화에 실패했습니다.',
    demoApplied: '데모 코드가 적용되었습니다!',
    preparingPayment: '결제 준비 중...',
    close: '닫기',
    promoCodeToggle: '프로모션 코드가 있으신가요?',
    completePurchase: '구매 완료하기',
    loadingRestore: '이전 결과 확인 중...'
  },

  // Japanese
  ja: {
    languageLabel: '\u8a00\u8a9e',
    enterName: 'お名前を教えてください',
    namePlaceholder: '例: John Smith（ファーストネームだけでもOK）',
    start: '\u59CB\u3081\u308B',
    next: '\u6B21\u3078',
    back: '戻る',

    yourKanjiName: '\u3042\u306A\u305F\u306E\u6F22\u5B57\u540D',
    matchingScore: '\u30DE\u30C3\u30C1\u30F3\u30B0\u5EA6',
    total: '\u7DCF\u5408',
    gender: '\u6027\u5225\u9069\u5408',
    motivation: '\u52D5\u6A5F\u9069\u5408',

    calligrapherTitle: '\u66F8\u9053\u5BB6\u304C\u3042\u306A\u305F\u306E\u540D\u524D\u3092\u7B46\u3067\u66F8\u304D\u307E\u3059',
    calligrapherDesc: '\u30D7\u30ED\u306E\u66F8\u9053\u5BB6\u304C\u3042\u306A\u305F\u306E\u6F22\u5B57\u540D\u3092\u7F8E\u3057\u3044\u7B46\u6587\u5B57\u3067\u66F8\u304D\u3001\u30E1\u30FC\u30EB\u3067\u304A\u5C4A\u3051\u3057\u307E\u3059\u3002',
    calligrapherDescPaid: '手書きの書道作品をお届けするため、メールアドレスを入力してください。',
    emailWarning: '※メールアドレスが間違っていた場合は、お届けすることができませんので慎重に入力してください。',
    emailPlaceholder: '\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9',
    request: '\u7533\u3057\u8FBC\u3080',
    sendCalligraphy: '申し込む',
    sending: '\u9001\u4FE1\u4E2D...',
    thankYou: '\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01\u66F8\u9053\u4F5C\u54C1\u306F1\u9031\u9593\u4EE5\u5185\u306B\u30E1\u30FC\u30EB\u306B\u3066\u304A\u5C4A\u3051\u3044\u305F\u3057\u307E\u3059\u3002',
    requestError: '\u9001\u4FE1\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002',
    shareTitle: '\u6F22\u5B57\u540D\u3092\u30B7\u30A7\u30A2\u3057\u3088\u3046',
    copyTag: '\u30B3\u30D4\u30FC',
    copyText: '\u30B3\u30D4\u30FC',

    landingTitle: 'あなただけの漢字名を手に入れよう',
    landingDesc: 'あなただけのオリジナル漢字名を作成し、プロの書道家が心を込めて手書きでお届けします。',
    feature1: 'あなたの内面を探る質問に回答',
    feature2: 'あなただけの漢字名を生成',
    feature3: 'プロの書道をメールでお届け',
    priceLabel: 'サービス料金',
    termsLink: '利用規約',
    startFree: '無料で始める',

    lpHeroTitle: 'あなたの日本語の名前は？',
    lpHeroSub: '性格診断 + 漢字の名前 + 書道 + あなただけの物語',
    lpHeroCta: '始める',
    lpHeroLang: '11言語対応',
    lpGalleryTitle: 'すべての名前に物語がある',
    lpGalleryMeaning1: '静かな完璧主義者、内に創造の炎を秘めて',
    lpGalleryMeaning2: '真実を見据え、迷いなく導く',
    lpGalleryMeaning3: '激しく自立しつつも、愛する人の中で最も温かい',
    lpGalleryMeaning4: '磨かれた翡翠のような知性、静かな湖のような安らぎ',
    lpHowTitle: 'ご利用の流れ',
    lpStep1: '2分の性格診断クイズに回答',
    lpStep2: 'メールアドレスを入力',
    lpStep3: 'あなたにピッタリの漢字名と意味をお届け',
    lpStep3Detail: '10分以内にメールでお届け',
    lpStep3Detail2: '手書きの書道は3営業日以内にお届け',
    lpProofText: '5,000人以上の旅行者に愛されています',
    lpCtaTagline: 'あなたの旅。あなたの名前。あなたの物語。',

    scrollHintCalligraphy: 'メールアドレスを入力して書道作品を受け取る',

    emailPromptMessage: '今からあなたの漢字名が生成されます。結果と毛筆の画像をメールで受け取りたい場合は、メールアドレスを入力してください。不要な場合は空欄のままでOKです。',
    emailPromptSkip: 'スキップ',
    emailPromptSubmit: '送信',

    loading1: '\u6027\u683C\u3092\u5206\u6790\u4E2D...',
    loading2: '\u6700\u9069\u306A\u6F22\u5B57\u3092\u9078\u5B9A\u4E2D...',
    loading3: '\u8AAC\u660E\u6587\u3092\u4F5C\u6210\u4E2D...',
    loading4: '次のページでメールアドレスを入力すると書道作品をお届けします',

    emailInputTitle: 'メールアドレスをご入力ください',
    emailInputDesc: '10分以内にあなたにピッタリの漢字名と説明文をお送りいたします',
    emailInputCalligraphy: '書道家による書道作品は3営業日以内（土日祝は除く）にお届けいたします',
    emailSubmittedThankYou: 'ありがとうございます！10分以内にあなたの漢字名と説明文をメールでお届けします。',
    emailSubmittedCalligraphy: '手書きの書道作品は3営業日以内（土日祝は除く）にお届けいたします。',

    // Error handling
    sessionError: 'セッションの準備に失敗しました。もう一度お試しください。',
    generationError: '結果の生成に失敗しました。もう一度お試しください。',
    paymentRequiredError: 'お支払いの確認ができませんでした。もう一度お試しください。',
    retry: '再試行',

    // Start new diagnosis
    startNew: '新しい診断を始める',

    // Payment modal
    paymentNotCompleted: 'お支払いが完了しませんでした。もう一度お試しください。',
    cancel: 'キャンセル',
    processing: '処理中...',
    payAndStart: '{{amount}}を支払って始める',
    demoCodeRequired: 'コードを入力してください',
    demoCodeInvalid: '無効なコードです',
    demoCodeError: '検証中にエラーが発生しました',
    demoValidating: '確認中...',
    demoApply: '適用',
    paymentInitFailed: '決済の初期化に失敗しました。',
    demoApplied: 'デモコードが適用されました！',
    preparingPayment: '決済を準備中...',
    close: '閉じる',
    promoCodeToggle: 'プロモコードをお持ちの方',
    completePurchase: 'お支払い手続き',
    loadingRestore: '前回の結果を確認中...'
  }
};

export default translations;
